import { Button, ButtonProps } from '@athena/forge';

export default function Link(props: Omit<ButtonProps<true>, 'variant'>) {
  return <Button variant="tertiary" useLink {...props}  />;
}
